module.exports = __webpack_public_path__ + "img/app_zyqlc.93fa136c.svg";